<template>
    <div>
       <a-card>
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :span="7">
              <a-form-item label="订单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-input v-model="orderNo" />
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-select v-model="payStatus">
                  <a-select-option :value="1">已支付</a-select-option>
                  <a-select-option :value="2">未支付</a-select-option>
                  <a-select-option :value="3">取消支付</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="7">
              <a-form-item label="操作日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                <a-range-picker @change="onChange" v-model="dataValue"/>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <span class="table-page-search-submitButtons">
          <a-button type="primary" @click="query">查询</a-button>
          <a-button style="margin-left: 8px" @click="reset">重置</a-button>
        </span>
      </div> 
        <a-spin :spinning="spinning">
      <a-table :pagination="pagination" size="default" ref="table" showHeader="false" :data-source="data5" :columns="columns5" bordered @change="changePage">
        <template slot="payType" slot-scope="payType"> {{payType==1?'线下支付':'支付宝'}}</template>
      </a-table>
      </a-spin>
      </a-card>
    </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
// import store from '@/store'  amount-enterprise
export default {
  name: 'walletRecord',
  components: {
  },
  computed: {
    ...mapGetters(['nickname', 'avatar'])
  },
  data() {
    return {
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      pagination: {
        current: 1,
        total: 0,
        pageSize: 10,//每页中显示10条数据
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],//每页中显示的数据
        showTotal: total => `共有 ${total} 条数据`,  //分页中显示总的数据
      },
      data5: [],
      datalist12: '',
      confirmLoading: false,
      queryParam: {},
      // 值订单账号
      orderNo: '', //订单号
      // rechargeId:'',
      // 状态
      status: 0,
      // 支付状态
      payStatus: '',
      // 后台返回的html
      html1: '',
      // 充值时间
      rechargeTime: '',
      dataValue:[],
      columns5: [
        {
          title: '充值订单账号',
          dataIndex: 'orderNo',
          align: 'center'
        },
        {
          title: '充值金额',
          dataIndex: 'rechargeMoney',
          align: 'center'
        },
        {
          title: '充值方式',
          dataIndex: 'payType',
          align: 'center',
          scopedSlots: { customRender: 'payType' },
        },
        {
          title: '状态 ',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '充值账号 ',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '充值时间 ',
          dataIndex: 'rechargeTime',
          align: 'center'
        },
        {
          title: '流水号',
          dataIndex: 'alipayId',
          align: 'center'
        }
      ],
      installTypes: [],
      visible19: false,
      rechargeNum: '',
      technicalIdArr: [],
      restaurantOperTypeMap: [],
      restaurantOperType: [],
      restaurantOperTypeMap2: [],
      time: null,
      handleRemoveRecord: '',
      removeStateNum: '',
      beOnDutyIndex: '',
      disGoBackAdd: false,
      createStartTime: null,
      createEndTime: null,
      updateStartTime: null,
      updateEndTime: null, //处理结束时间
      deleteStartTime: null,
      deleteEndTime: null,
      enterpriseId:this.$store.getters.enterpriseId,
      startTime:'',//开始时间
      endTime:'',//结束时间
      spinning:false,//加载指示符
    }
  },
  created() {
    this.information3()
    this.query()
  },
  methods: {
    // 重置
    reset() {
      this.orderNo = ''
      this.payStatus = ''
      this.startTime=''
      this.endTime=''
      this.dataValue=[]
      this.spinning=true
      this.$axios({
        method: 'get',
        url: '/api/finance/refund/get/' + `${this.enterpriseId}`,
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.$axios({
          method: 'get',
          url: '/api/finance/recharge/list',
          params: {
            enterpriseId: this.enterpriseId
          },
          headers: {
            token: Vue.ls.get(ACCESS_TOKEN),
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(res => {
          this.data5 = res.data.rows
          this.pagination.current=1
          this.spinning=false
        })
      })
    },
    // 充值列表
    information3() {
      this.spinning=true
      this.$axios({
        method: 'get',
        url: '/api/finance/recharge/list/',
        params: {
          orderNo: this.orderNo,
          enterpriseId: this.enterpriseId,
          startTime: this.startTime,
          status: this.payStatus,
          endTime:this.endTime
        },
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN),
          'Content-Type': 'application/json;charset=UTF-8'
        }
      }).then(res => {
        this.data5 = res.data.rows
        this.spinning=false
        })
    },
    // 查询
    query() {
      this.pagination.current=1
      this.information3()
    },
    //时间选择
    onChange(value,dataString){
        this.startTime = dataString[0]
        this.endTime = dataString[1]
    },
    changePage(e){
    const { current, pageSize } = e;
    this.pagination.current = current;
    this.pagination.pageSize = pageSize;
    }
  },
  watch:{
   $route(to,from){
     this.information3()
   }
  }
}
</script>
<style scoped>

</style>
